
import InfoTable from '../components/info_table.vue'
import { EnterpriseService } from '@/services'
import { Component, Vue } from 'vue-property-decorator'

@Component({
    name: 'info-edit-list',
    components: {
        InfoTable
    }
})
export default class extends Vue {
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private infoList = []
    private status = 0
    private statusOpitons = [
        { key: 0, value: '全部' },
        { key: 1, value: '待审核' },
        { key: 2, value: '通过' },
        { key: 3, value: '不通过' }
    ]
    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getList()
    }

    private mounted() {
        this.getList()
    }

    /* 获取申请列表 */
    private async getList() {
        this.isLoading = true
        const status = this.status || undefined
        const params = {
            status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await EnterpriseService.getEditInfoList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.infoList = result.data.list
        }
        this.isLoading = false
    }
}
